// MindmappingSectionb_js
import React, { useState, useEffect } from "react";
import { FaArrowLeftLong } from "react-icons/fa6";
import { Link, useNavigate, useLocation } from "react-router-dom";
import { ToastContainer, toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import { useRef } from "react";

import "./MindMapSecB.css";

export default function Tools() {
  const location = useLocation();

  const navigate = useNavigate();
  const isLeavingRef = useRef(false);
  
const goToMorePage = (type) => {
  navigate(`/mind-mapping/sec-b/${type}`);
};



  // ================= STATE VARIABLES =================
  const [popupOpen, setPopupOpen] = useState(false);
  const [selectedTool, setSelectedTool] = useState("");
  // eslint-disable-next-line no-unused-vars
  const [formErrors,setFormErrors] = useState({});
  const [skillInput, setSkillInput] = useState("");
  const [skills, setSkills] = useState([]);
  const [notifyLoading, setNotifyLoading] = useState(false);
  const [isAlreadyRequested, setIsAlreadyRequested] = useState(false);
const [loadingGoalUsecases, setLoadingGoalUsecases] = useState(false);
const [goalUsecases, setGoalUsecases] = useState([]);
// eslint-disable-next-line no-unused-vars
const [skillsLoading, setSkillsLoading] = useState(false);
const [isSkillEmptyPopup, setIsSkillEmptyPopup] = useState(false);
// eslint-disable-next-line no-unused-vars
const [skillButtons, setSkillButtons] = useState([]);
// eslint-disable-next-line no-unused-vars
const [sectorButtons, setSectorButtons] = useState([]);
// eslint-disable-next-line no-unused-vars
const [districtButtons, setDistrictButtons] = useState([]);



const isSectionB = location.pathname.startsWith("/mind-mapping/sec-b");

const safeNavigate = (path) => {
  setPopupOpen(false);
  setSelectedTool("");
  isLeavingRef.current = true;
  navigate(path);
};

useEffect(() => {
  if (!isSectionB) {
    setPopupOpen(false);
    setSelectedTool("");
    isLeavingRef.current = true;
  }
}, [isSectionB]);

const [isDarkMode, setIsDarkMode] = useState(
  document.body.classList.contains("dark-mode")
);

useEffect(() => {
  const observer = new MutationObserver(() => {
    setIsDarkMode(document.body.classList.contains("dark-mode"));
  });

  observer.observe(document.body, {
    attributes: true,
    attributeFilter: ["class"],
  });

  return () => observer.disconnect();
}, []);


const groupedGoalUsecases = goalUsecases.reduce((acc, item) => {
  if (!acc[item.goal_name]) {
    acc[item.goal_name] = [];
  }
  acc[item.goal_name].push(item.usecase);
  return acc;
}, {});


  const [loggedUser, setLoggedUser] = useState({
    name: "",
    email: ""
  });

  const [descriptions, setDescriptions] = useState([]);
  const [otherDistricts, setOtherDistricts] = useState([]);
  const [usecases, setUsecases] = useState([]);

  // const goToTechProduct = (techName) => {
  //   const product = SampleProducts.find(
  //     (p) => p.name.toLowerCase() === techName.toLowerCase()
  //   );
  //   if (product) {
  //     navigate(`/business-product/${product.id}`, { state: { product } });
  //   } else {
  //     navigate(`/business-product/not-found`, { state: { product: null } });
  //   }
  //   closePopup();
  // };

  useEffect(() => {
    fetch(`${process.env.REACT_APP_BACKEND_URL}/auth/me`, {
      credentials: "include",
    })
      .then(res => res.json())
      .then(data => {
        if (data.user) {
          localStorage.setItem("user_id", data.user.user_id);
          setLoggedUser({
            name: data.user.name || "",
            email: data.user.email || ""
          });
        }
      })
      .catch(() => {
        localStorage.removeItem("user_id");
      });
  }, []);

  useEffect(() => {
    const handleRealResize = () => {
      const isRealMobile = window.screen.width <= 600;
      document.body.classList.toggle("real-mobile", isRealMobile);
    };
    handleRealResize();
    window.addEventListener("resize", handleRealResize);
    return () => window.removeEventListener("resize", handleRealResize);
  }, []);

  useEffect(() => {
    const sector = localStorage.getItem("selectedSector");
    const sectorType = localStorage.getItem("selectedSectorType");
    if (!sector || !sectorType) return;
   fetch(
  `${process.env.REACT_APP_BACKEND_URL}/api/mind-mapping/sector-descriptions` +
  `?sector=${encodeURIComponent(sector)}` +
  `&sectorType=${encodeURIComponent(sectorType)}`
)

      .then((res) => res.json())
    .then((data) => {
  if (Array.isArray(data)) {
    setDescriptions(data.slice(0, 5));
  } else if (Array.isArray(data.descriptions)) {
    setDescriptions(data.descriptions.slice(0, 5));
  } else {
    setDescriptions([]);
  }
})

      .catch((err) => console.error("Sector description error:", err));
  }, []);

 useEffect(() => {

 const sector = localStorage.getItem("selectedSector");
 const sectorType = localStorage.getItem("selectedSectorType");

 if (!sector || !sectorType) return; // ⭐ ADD THIS

 fetch(`${process.env.REACT_APP_BACKEND_URL}/api/mind-mapping/sector-descriptions-next?sector=${encodeURIComponent(sector)}&sectorType=${encodeURIComponent(sectorType)}`)
   .then(res=>res.json())
   .then(data=>{
      console.log("NEXT SECTORS:", data);
      setSectorButtons(data);
   });

},[]);



  useEffect(() => {
    const district = localStorage.getItem("selectedDistrict");
    const stateId = localStorage.getItem("selectedStateId");
    if (!district) return;
    let url = `${process.env.REACT_APP_BACKEND_URL}/api/mind-mapping/other-district-industries?excludeDistrict=${district}`;
   if (stateId) url += `&state_id=${stateId}`;

   fetch(url, { credentials: "include" })
  .then((res) => {
    if (!res.ok) throw new Error("Failed to fetch districts");
    return res.json();
  })
  .then((data) => {
  if (Array.isArray(data) && data.length > 0) {
    setOtherDistricts(
      data.filter(
        (d) => d.district_name && d.line_of_activity
      )
    );
  } else {
    setOtherDistricts([]);
  }
})

  .catch((err) => {
    console.error("Other district industries error:", err);
    setOtherDistricts([]);
  });

  }, []);

 useEffect(() => {

 const district = localStorage.getItem("selectedDistrict");
 const stateId = localStorage.getItem("selectedStateId");

 if (!district || !stateId) return; // ⭐ ADD THIS

 fetch(`${process.env.REACT_APP_BACKEND_URL}/api/mind-mapping/other-district-industries-next?excludeDistrict=${district}&state_id=${stateId}`)
   .then(res=>res.json())
   .then(data=>{
      console.log("NEXT DISTRICTS:", data);
      setDistrictButtons(data);
   });

},[]);



  const skillsLoadedRef = useRef(false);

 const courseId = localStorage.getItem("course_id");

useEffect(() => {
  skillsLoadedRef.current = false;
  setUsecases([]);
}, [courseId]);

useEffect(() => {

  const course_id = localStorage.getItem("course_id");
  if (!course_id) return;

  fetch(`${process.env.REACT_APP_BACKEND_URL}/api/mind-mapping/startups/usecases/${course_id}`)
    .then(res => res.json())
    .then(data => {

      if (!Array.isArray(data)) return;

      // remove first 5
      setSkillButtons(data.slice(5));

    })
    .catch(err => console.error("Skills button error:", err));

}, []);



useEffect(() => {
  const goals = JSON.parse(localStorage.getItem("selected_goals"));

  if (!goals || goals.length !== 6) {
    console.warn("Goals not found or not exactly 6");
    return;
  }

  setLoadingGoalUsecases(true);

  fetch(`${process.env.REACT_APP_BACKEND_URL}/api/mind-mapping/usecases-by-goals`, {

    method: "POST",
    headers: {
      "Content-Type": "application/json",
    },
    body: JSON.stringify({ goals }),
  })
    .then((res) => res.json())
    .then((data) => {
       setGoalUsecases(data); // [{ usecase: "..." }]
    })
    .catch((err) => {
      console.error("Usecase fetch error:", err);
      setUsecases([]);
    })
    .finally(() => setLoadingGoalUsecases(false));
}, []);


 const openPopup = async (name) => {
  // reset first
  setIsSkillEmptyPopup(false);
  setUsecases([]);
  setIsAlreadyRequested(false);

  if (name !== "Skills") {
    setSelectedTool(name);
    setPopupOpen(true);
    return;
  }

  // ===== SKILLS FLOW =====
  const course_id = localStorage.getItem("course_id");
  const userId = localStorage.getItem("user_id");
  if (!course_id) return;

  setSkillsLoading(true);

  try {
    const res = await fetch(
      `${process.env.REACT_APP_BACKEND_URL}/api/mind-mapping/startups/usecases/${course_id}`
    );
    const data = await res.json();

    // 🔥 DECIDE SIZE FIRST
    const isEmpty = data.length === 0;

    setUsecases(data);
    setIsSkillEmptyPopup(isEmpty);

    if (isEmpty && userId) {
      const statusRes = await fetch(
        `${process.env.REACT_APP_BACKEND_URL}/mindmappingsectionB/skill-interest/status?userId=${userId}&courseId=${course_id}`,
        { credentials: "include" }
      );
      const statusData = await statusRes.json();
      setIsAlreadyRequested(statusData.requested);
    }

    // 🔥 OPEN POPUP ONLY ONCE (FINAL STATE)
    setSelectedTool("Skills");
    setPopupOpen(true);

  } catch (err) {
    console.error("Skills popup error:", err);
  } finally {
    setSkillsLoading(false);
  }
};

  const closePopup = () => {
    setPopupOpen(false);
    setSelectedTool("");
  };

  const handleNotifyMe = async () => {
    const userId = localStorage.getItem("user_id");
    const courseId = localStorage.getItem("course_id");
    const graduationCourse = localStorage.getItem("graduation_course");
    const department = localStorage.getItem("department");

    if (!userId) { toast.error("Please login to get notified"); return; }
    if (!courseId) { toast.warning("Please select a course first"); return; }
    if (notifyLoading) return;
    setNotifyLoading(true);
    try {
      const res = await fetch(`${process.env.REACT_APP_BACKEND_URL}/mindmappingsectionB/skill-interest`, {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        credentials: "include",
        body: JSON.stringify({ userId, courseId, graduationCourse, department }),
      });
      const data = await res.json();
      if (res.status === 201 && data.success) {
        localStorage.setItem(`notified_${courseId}`, "true");
        setIsAlreadyRequested(true);
        toast.success("We’ll notify you when it’s available 🚀");
         isLeavingRef.current = true;
        setPopupOpen(false);
setSelectedTool("");
safeNavigate("/dashboard");


        closePopup();
        return;
      }
      if (res.status === 409) {
        setIsAlreadyRequested(true);
        toast.info(data.message || "Already requested");
        closePopup();
        return;
      }
      toast.error(data.message || "Something went wrong");
    } catch (err) {
      toast.error("Server error. Please try again later.");
    } finally {
      setNotifyLoading(false);
    }
  };

  const handleSkillKeyDown = (e) => {
    if (e.key === "Enter" || e.key === ",") {
      e.preventDefault();
      const value = skillInput.trim();
      if (!value) return;
      if (skills.includes(value)) { setSkillInput(""); return; }
      setSkills([...skills, value]);
      setSkillInput("");
    }
  };

  const removeSkill = (skillToRemove) => setSkills(skills.filter((s) => s !== skillToRemove));
  const handleCustomBuild = () => setSelectedTool("Custom Build Form");
  const handleBackToEmptySkills = () => setSelectedTool("Skills");

  const handleCustomBuildSubmit = async (e) => {
    e.preventDefault();
    const name = loggedUser.name.trim();
    const email = loggedUser.email.trim();
    const mobile = e.target.mobile.value.trim();
    const wantedSkills = skills.join(", ");
    if (skills.length === 0) { setFormErrors({ wantedSkills: "Please add at least one skill" }); return; }
    try {
      await fetch(`${process.env.REACT_APP_BACKEND_URL}/mindmappingsectionB/custom-build`, {
        method: "POST",
        headers: { "Content-Type": "application/json" },
         credentials: "include",
        body: JSON.stringify({ name, email, mobile, wantedSkills }),
      });
      closePopup();
     setPopupOpen(false);
setSelectedTool("");
safeNavigate("/dashboard");


      toast.success("Custom request submitted!");
    } catch (err) {
      toast.error("Failed to submit");
    }
  };



  return (
    <>
      <div className="tools-wrapper">
      <div className="mindmap-content">   {/* 🔥 NEW WRAPPER */}

    <div className="mindmap-header">
      <div className="header-left">
        <button className="mapping-back-btn" onClick={() => navigate(-1)}>
          <FaArrowLeftLong className="mindmap-back-icon" />
          <span className="back-text">Back</span>
        </button>
      </div>

      <h1 className="mindmap-title">
        Founder Fit Startup Idea Discovery
      </h1>

      <div className="header-right" />
    </div>


        <div className="mindmap-scale-root">
        <div className="arc-wrapper">
        <div className="center-circle">
        <img
          src="/image/center.png"
          alt="Center Icon"
          className="center-icon"
        />
        <span>Marsmate AI</span>
      </div>
        <div className="arc-holder">
          <div className="semi-circle-wrapper">
          <svg
            className="semi-circle-svg"
            width="260"
            height="160"
            viewBox="0 0 260 160"
          >
            <path
              d="M30 25 A100 100 0 0 0 230 25"
              fill="none"
              stroke="#1b4a76"
              strokeWidth="3"
              strokeLinecap="round"
            />

            <path
              d="M30 25 A100 100 0 0 0 230 25"
              fill="none"
              stroke="#0084ff"
              strokeWidth="8"
              strokeLinecap="round"
              pathLength="5"
              strokeDasharray="0.01 0.99"
            />
          </svg>
        </div>
        </div>
        {/* ===== NEW MARS MATE FLOWER ===== */}

<button
  className="trap-card pos-skill rot-left-top"
  onClick={() => openPopup("Skills")}
>
  <img src="/image/trapezoid-curved.svg" className="card-bg" alt="" />
  <img
  className="card-icon icon-skill"
  src={
    isDarkMode
      ? "/image/dark-skills.png"
      : "/image/skills.png"
  }
  alt="Skills"
/>

  <span>Skills</span>
</button>

<button
  className="trap-card pos-goals rot-right-top"
  onClick={() => openPopup("Goal Usecases")}
>
  <img src="/image/trapezoid-curved.svg" className="card-bg" alt="" />
  <img className="card-icon icon-goals" src="/image/goals.png" alt="" />
  <span>Goals</span>
</button>

<button
  className="trap-card pos-sector rot-left-mid"
  onClick={() => openPopup("Sector Insights")}
>
  <img src="/image/trapezoid-curved.svg" className="card-bg" alt="" />
  <img className="card-icon icon-sector" src="/image/sector.png" alt="" />
  <span>Sector Insights</span>
</button>

<button
  className="trap-card pos-tech rot-right-mid"
  onClick={() => openPopup("Ready Made TECH's")}
>
  <img src="/image/trapezoid-curved.svg" className="card-bg" alt="" />
 <img
  className="card-icon icon-tech"
  src={
    isDarkMode
      ? "/image/dark-tech.png"
      : "/image/tech.png"
  }
  alt="Ready Made Tech"
/>

  <span>Ready Made Tech’s</span>
</button>

<button
  className="trap-card pos-district rot-bottom"
  onClick={() => openPopup("Nearby Districts")}
>
  <img src="/image/trapezoid-curved.svg" className="card-bg" alt="" />
  <img className="card-icon icon-district" src="/image/districts.png" alt="" />
  <span>Nearby Districts</span>
</button>
</div>
</div>

<div className="reports-bar">
  <button className="report-btn left" onClick={() => {
    navigate(`/reports-hub`, { state: { tab: "mm" } });
  }}>
    View Full Reports
  </button>
</div>
</div>

        <div className="criteria-buttons">
          <button onClick={() => goToMorePage("sector-more")}>Zero / Less Competition</button>
          <button onClick={() => goToMorePage("district-more")}>Budget Friendly</button>
          <button onClick={() => goToMorePage("skills-more")}>Skill Set Based</button>
          <button onClick={() => goToMorePage("goals-more")}>Passion to Start</button>
          <button onClick={() => openPopup("1°")}>1°</button>
          <button onClick={() => openPopup("2°")}>2°</button>
          <button onClick={() => openPopup("3°")}>3°</button>
          <button onClick={() => goToMorePage("readymade-techs")}> Reference / Pivot</button>

        </div>
      </div>

     {popupOpen && isSectionB && (
  <div className="sectionb-overlay">
    <div
  className={`popup-content ${
    selectedTool === "Skills" && isSkillEmptyPopup
      ? "popup-small"
      : ""
  }`}
>

      {/* ===== CLOSE BUTTON ===== */}
      <button className="close-btn" onClick={closePopup}>
        ✕
      </button>

      {/* ===== HEADER ===== */}
      {!(selectedTool === "Skills" && selectedTool !== "Custom Build Form" && usecases.length === 0) && (
        <h2>{selectedTool}</h2>
      )}

      {/* ===== SCROLLABLE BODY ===== */}
      <div className="popup-scroll-body">
        {selectedTool === "Sector Insights" && (
          <ul>
            {Array.isArray(descriptions) &&
  descriptions.slice(0, 5).map((d, i) => (
    <li key={i}>{d.description}</li>
  ))}

          </ul>
        )}

        {selectedTool === "Nearby Districts" && (
          <ul>
            {Array.isArray(otherDistricts) && otherDistricts.length > 0 ? (
              otherDistricts.map((d, i) => (
                <li key={i}>
                  <b>{d.district_name || "Unknown District"}</b>
                  <br />
                  Unit: {d.unit_name || "N/A"}
                  <br />
                  Activity: {d.line_of_activity || "N/A"}
                </li>
              ))
            ) : (
              <p>No district data available</p>
            )}
          </ul>
        )}

        {selectedTool === "Skills" && (
          <>
            {usecases.length > 0 ? (
              <ul className="usecase-list">
                {usecases.map((u, i) => (
                  <li key={i}>
                    <p>{u.usecase}</p>
                  </li>
                ))}
              </ul>
            ) : (
              <div className="empty-skill-box">
                <h3>Hence you want this technology</h3>

                <div className="empty-skill-actions">
                  <button
                    onClick={
                      isAlreadyRequested ? undefined : handleNotifyMe
                    }
                    disabled={notifyLoading || isAlreadyRequested}
                  >
                    {isAlreadyRequested
                      ? "Already Requested"
                      : notifyLoading
                      ? "Please wait..."
                      : "When it is available – Notify Me"}
                  </button>

                  <button onClick={handleCustomBuild}>
                    Custom Build
                  </button>
                </div>
              </div>
            )}
          </>
        )}

      {selectedTool === "Ready Made TECH's" && (
  <ul className="qlik-tech-list">
    <li>
      <Link to={`/business-product/CB3030CHAT987XY`}>
        Chat Bot
      </Link>
    </li>

    <li>
      <Link to={`/business-product/AT8989XYTRAD12`}>
        Algo Trading Tech
      </Link>
    </li>

    <li>
      <Link to={`/business-product/AP88776655APT44S`}>
        Apartment Tech
      </Link>
    </li>

    <li>
      <Link to={`/business-product/MR112233MEDREP9Z`}>
        Medical Report Tech
      </Link>
    </li>

    <li>
      <Link to={`/business-product/EC56565656EFEFEF`}>
        E-Commerce Tech
      </Link>
    </li>
  </ul>
)}


        {selectedTool === "Goal Usecases" && (
          <>
            {loadingGoalUsecases && <p>Loading goal usecases...</p>}

            {!loadingGoalUsecases &&
              Object.entries(groupedGoalUsecases).map(
                ([goalName, cases]) => (
                  <div key={goalName} className="goal-usecase-block">
                    <h3>{goalName}</h3>
                    <ul className="usecase-list">
                      {cases.map((u, i) => (
                        <li key={i}>{u}</li>
                      ))}
                    </ul>
                  </div>
                )
              )}
          </>
        )}

        {selectedTool === "Custom Build Form" && (
          <form
            className="custom-build-form"
            onSubmit={handleCustomBuildSubmit}
          >
            <span
              className="custom-build-back-arrow"
              onClick={handleBackToEmptySkills}
            >
              ←
            </span>

            <input
              name="name"
              placeholder="Name"
              value={loggedUser.name}
              onChange={(e) =>
                setLoggedUser({ ...loggedUser, name: e.target.value })
              }
              required
            />

            <input
              name="email"
              type="email"
              placeholder="Email"
              value={loggedUser.email}
              onChange={(e) =>
                setLoggedUser({ ...loggedUser, email: e.target.value })
              }
              required
            />

            <input
              name="mobile"
              placeholder="Mobile Number"
              required
              pattern="[0-9]{10}"
              inputMode="numeric"
            />

            <div className="skills-input-wrapper">
              <input
                type="text"
                placeholder="Type Technology What You Need"
                value={skillInput}
                onChange={(e) => setSkillInput(e.target.value)}
                onKeyDown={handleSkillKeyDown}
              />

              {skills.length > 0 && (
                <div className="skills-chips">
                  {skills.map((skill, index) => (
                    <span className="skill-chip" key={index}>
                      {skill}
                      <button
                        type="button"
                        className="remove-skill"
                        onClick={() => removeSkill(skill)}
                      />
                    </span>
                  ))}
                </div>
              )}
            </div>

            <button type="submit">Submit</button>
          </form>
        )}

        {selectedTool !== "Sector Insights" &&
          selectedTool !== "Nearby Districts" &&
          selectedTool !== "Skills" &&
          selectedTool !== "Ready Made TECH's" &&
          selectedTool !== "Custom Build Form" &&
          selectedTool !== "Goal Usecases" && (
            <p>
              Details related to <b>{selectedTool}</b>
            </p>
          )}
      </div>
    </div>
  </div>
)}


      <ToastContainer position="bottom-right" autoClose={3000} />
    </>
  );
}